import {
  selectBtCapabilities,
  type BtCapabilitiesState,
  type PaymentMethodIdentity,
} from './basisTheorySelectors';

type CardCheckoutMode = 'basis_theory' | 'legacy';

interface CardCheckoutDecision {
  mode: CardCheckoutMode;
}

/** Select the card-capture flow shared by the form, pay button, and payment action. */
function selectCardCheckoutDecision(
  state: BtCapabilitiesState,
  paymentMethod: PaymentMethodIdentity | null | undefined,
): CardCheckoutDecision {
  const { checkoutEnabled } = selectBtCapabilities(state, paymentMethod);
  const mode: CardCheckoutMode = checkoutEnabled ? 'basis_theory' : 'legacy';

  return { mode };
}

export type { CardCheckoutDecision, CardCheckoutMode };
export { selectCardCheckoutDecision };
